/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Submit_JobInputs */

const en_submit_job = /** @type {(inputs: Submit_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Submit ${i?.count} Job`)
};

const fr_submit_job = /** @type {(inputs: Submit_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Soumettre ${i?.count} tâche`)
};

const de_submit_job = /** @type {(inputs: Submit_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}-Job einreichen`)
};

const it_submit_job = /** @type {(inputs: Submit_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Invia ${i?.count} Lavoro`)
};

const ru_submit_job = /** @type {(inputs: Submit_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Отправить задание ${i?.count}`)
};

const es_submit_job = /** @type {(inputs: Submit_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enviar trabajo ${i?.count}`)
};

const zh_cn2_submit_job = /** @type {(inputs: Submit_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`提交 ${i?.count} 工作`)
};

const ja_submit_job = /** @type {(inputs: Submit_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ジョブを送信`)
};

const hi_submit_job = /** @type {(inputs: Submit_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} जॉब सबमिट करें`)
};

const pt_pt2_submit_job = /** @type {(inputs: Submit_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Submeter vaga ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Submit {count} Job" |
*
* @param {Submit_JobInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const submit_job = /** @type {((inputs: Submit_JobInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Submit_JobInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_submit_job(inputs)
	if (locale === "de") return de_submit_job(inputs)
	if (locale === "it") return it_submit_job(inputs)
	if (locale === "ru") return ru_submit_job(inputs)
	if (locale === "es") return es_submit_job(inputs)
	if (locale === "zh-CN") return zh_cn2_submit_job(inputs)
	if (locale === "ja") return ja_submit_job(inputs)
	if (locale === "hi") return hi_submit_job(inputs)
	if (locale === "pt-PT") return pt_pt2_submit_job(inputs)
	return en_submit_job(inputs)
});